module.exports = __webpack_public_path__ + "img/5.f45e4b47.png";